import BaseScene from "./BaseScene";

import characters from "../../assets/img/spash/splash-characters.png";
import logo1 from "../../assets/img/spash/logo-NCSC.png";
import logo2 from "../../assets/img/spash/logo-cyber-first.png";

import ImageButton from "../components/ImageButton";
import { PostPipeline } from "../plugins/global/PostEffectPlugin";

import AmbientBackgroundSounds from "../../assets/audio/ambience.ogg";
import AmbientBackgroundSoundsMP3 from "../../assets/audio/ambience.mp3";
import NegativeFlickerHitSound from "../../assets/audio/CK_Sensors-13.ogg";
import NegativeFlickerHitSoundMP3 from "../../assets/audio/CK_Sensors-13.mp3";

import SplashSpriteTexture from "../../assets/atlas/splash.png";
import SplashSpriteData from "../../assets/atlas/splash.json";

/**
 *
 * @category scenes
 * @export
 * @class SplashScene
 * @extends {BaseScene}
 */
export default class SplashScene extends BaseScene {
  titleCyber: Phaser.GameObjects.Image;
  titleSprinters: Phaser.GameObjects.Image;
  characters: Phaser.GameObjects.Image;
  bgSound: Phaser.Sound.BaseSound;
  glitchSound: Phaser.Sound.BaseSound;
  subtitle: Phaser.GameObjects.Text;

  effects: boolean;

  constructor() {
    super({
      key: "SplashScene",
      active: false, // false means this state isn't loaded on boot. true means its instantly activated.
    });

    console.log("SplashScene::constructor");
  }

  preload(): void {
    console.log("SplashScene::preload");

    this.load.atlas("splash", SplashSpriteTexture, SplashSpriteData);

    this.load.image("splash-characters", characters);

    this.load.image("logo1", logo1);

    this.load.image("logo2", logo2);

    this.load.audio("ambient-menu-sound", [
      AmbientBackgroundSounds,
      AmbientBackgroundSoundsMP3,
    ]);

    this.load.audio("negative-flicker-sound", [
      NegativeFlickerHitSound,
      NegativeFlickerHitSoundMP3,
    ]);

    super.preload();
  }

  /**
   * create any gameObjects that are required here.
   *
   * @memberof SplashScene
   */
  create(): void {
    //create game objects.

    // this.scene.remove("EndlessRunnerScene");
    // this.scene.add("EndlessRunnerScene", EndlessRunnerScene, false);

    this.add.image(
      this.cameras.main.centerX,
      this.cameras.main.centerY,
      "splash",
      "splash-page-bg.png"
    );

    this.add.image(260, 115, "logo1");

    this.add.image(520, 115, "logo2");

    // this.sponge.effects.addDigitalScan(this.characters);
    this.effects = this.sponge.effects.addMainGamePost(this);

    this.titleCyber = this.add.image(
      this.cameras.main.centerX,
      270,
      "splash",
      "cyber.png"
    );
    this.titleSprinters = this.add.image(
      this.cameras.main.centerX,
      400,
      "splash",
      "sprinters.png"
    );

    this.subtitle = this.add
      .text(
        this.cameras.main.centerX,
        470,
        this.sponge.data.model.content.strings.splashSubtitle,
        this.sponge.data.model.fonts.question
      )
      .setOrigin(0.5, 0)
      .setFontSize(28)
      .setWordWrapWidth(600)
      .setAlpha(0);

    this.characters = this.add.image(
      this.cameras.main.centerX,
      this.cameras.main.centerY + 150,
      "splash-characters"
    );

    if (this.effects) {
      this.characters.scaleY = -1;
      this.characters.y = this.cameras.main.height - this.characters.y;
    }
    //TODO: if webgl renederer not avalible.

    this.sponge.effects.addGlitch(this.characters);

    if (this.effects)
      (this.cameras.main.pipeline as PostPipeline).effectProgress = 0;

    this.titleCyber.setScale(0);
    this.titleSprinters.setScale(0);

    this.add.tween({
      ease: "Back.easeOut",
      targets: this.titleCyber,
      duration: 600,
      scaleX: 0.8,
      scaleY: 0.8,
    });
    this.add.tween({
      ease: "Back.easeOut",
      targets: this.titleSprinters,
      delay: 200,
      duration: 600,
      scaleX: 0.8,
      scaleY: 0.8,
    });
    this.add.tween({
      ease: "Bounce.easeOut",
      targets: this.subtitle,
      delay: 800,
      duration: 600,
      alpha: 1,
    });

    this.characters.setAlpha(0);

    this.add.tween({
      ease: "Quad.easeOut",
      targets: this.characters,
      duration: 600,
      alpha: 1,
    });

    const startButton = new ImageButton(
      this,
      this.cameras.main.centerX,
      1100,
      this.sponge.data.model.content.strings.start,
      () => {
        this.showInstructions();
      },
      "submitButton"
      // () => {
      //   this.sponge.startVO("splash-intro-start", this);
      // }
    );

    this.add
      .text(
        this.cameras.main.centerX,
        1200,
        "© Crown Copyright",
        this.sponge.data.model.fonts.h1
      )
      .setAlign("center")
      .setFill("#FFFFFF")
      .setOrigin(0.5);
    //popup
    // this.sponge.popup.launchPopup("test", () => {
    //   //what to do when the popup is dismissed
    //   console.log("popup dismissed");
    // });
    // //mark as complete
    // this.sponge.tracking.complete(0.2);
    // //update save and persist
    // this.sponge.data.save.progress = 1;
    // this.sponge.tracking.save();
    // const ret = this.add.rectangle(100, 100, 100, 100, 0xff00aa, 0.5);
    // ret.setInteractive();
    // ret.on("pointerup", this.onClickGameObject, this);

    this.bgSound = this.sound.add("ambient-menu-sound", {
      volume: 0.1,
      loop: true,
    });

    this.bgSound.play();

    this.glitchSound = this.sound.add("negative-flicker-sound", {
      volume: 0.3,
      loop: false,
    });

    this.glitch();

    //this.sponge.startVO("splash-intro", this);
  }

  showInstructions() {
    this.sponge.popup.launchPopup("how-to-play", () => {
      this.showInfoScene();
    });

    if (this.sponge.data.save.seenInstructions.indexOf("how-to-play") === -1) {
      this.sponge.data.save.seenInstructions.push("how-to-play");
      this.sponge.tracking.save();
      //console.log("added instructions to array")
    } else {
      //make close button permanent on popup so skippable
      this.sponge.popup.makePersistantClose();
      this.sponge.popup.updateCloseLabel(
        this.sponge.data.model.content.strings.skipInstructions
      );
      //console.log("added persistant close to instructions popup")
    }
  }

  showInfoScene() {
    this.scene.start("InfoIntroScene");
    this.shutdown();
  }

  glitch() {
    if (!this.effects) {
      return;
    }

    if (this.characters && this.glitchSound) {
      (this.characters.pipeline as PostPipeline).fire(this, 400, 0.2);
      this.glitchSound.play();

      this.time.delayedCall(
        Math.random() * 8000 + 2000,
        this.glitch,
        undefined,
        this
      );
    }
  }

  onClickGameObject(): void {
    console.log(this); //this will equal this SplashScene
  }

  /**
   * update is called on each frame, when the scene is in an active, non sleep state.
   *
   * @param {number} time time since app launch
   * @param {number} delta miliseconds since update.
   * @memberof SplashScene
   */
  update(time: number, delta: number): void {
    super.update(time, delta);
  }

  /**
   * destroy and remove this scene from memory.
   *
   * @memberof SplashScene
   */
  shutdown(): void {
    console.log("SplashScene::shutdown");

    this.bgSound.stop();

    super.shutdown();
  }
}
